import { motion } from "framer-motion";
import { useEffect, useState } from "react";
const pageVariants = {
  initial: { opacity: 0, x: 80 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -80 },
};
const staggerChildren = {
  animate: { transition: { staggerChildren: 0.15 } },
};
const fadeUp = {
  initial: { opacity: 0, y: 40 },
  animate: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: "easeOut" },
  },
};
function About() {
  const works = [
    "/1.jpeg",
    "/2.jpeg",
    "/3.jpeg",
    "/4.jpeg",
    "/5.jpeg",
    "/6.jpeg",
    "/7.jpeg",
    "/8.jpeg",
    "/9.jpeg",
    "/10.jpeg",
  ];
  const [currentSlide, setCurrentSlide] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % works.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [works.length]);
  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.6, ease: "easeInOut" }}
    >
      <section
        style={{
          paddingTop: "140px",
          paddingBottom: "80px",
          paddingInline: "10%",
          background: "linear-gradient(135deg, var(--ink) 0%, #3b1f6b 100%)",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            width: "600px",
            height: "600px",
            borderRadius: "50%",
            border: "2px solid rgba(232,160,32,0.12)",
            top: "-200px",
            right: "-150px",
          }}
        />
        <motion.span
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.7 }}
          style={{
            fontFamily: "var(--font-hand)",
            fontSize: "1.3rem",
            color: "var(--teal)",
            letterSpacing: "3px",
          }}
        >
          ✦ Our Story ✦
        </motion.span>
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.8 }}
          style={{
            fontFamily: "var(--font-serif)",
            fontStyle: "italic",
            fontSize: "clamp(2.5rem, 6vw, 4rem)",
            fontWeight: 900,
            color: "#fff",
            marginTop: "12px",
            lineHeight: 1.1,
          }}
        >
          About Artem Clava
        </motion.h1>
      </section>
      <section style={{ padding: "80px 10%", background: "var(--cream)" }}>
        <motion.div
          variants={staggerChildren}
          initial="initial"
          whileInView="animate"
          viewport={{ once: true }}
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit,minmax(320px,1fr))",
            gap: "60px",
            alignItems: "center",
          }}
        >
          <motion.div variants={fadeUp}>
            <div
              style={{
                position: "relative",
                display: "inline-block",
                marginBottom: "28px",
              }}
            >
              <h2
                style={{
                  fontFamily: "var(--font-serif)",
                  fontSize: "2.2rem",
                  fontWeight: 700,
                  color: "var(--ink)",
                }}
              >
                Where Art Becomes Life
              </h2>
              <motion.div
                initial={{ scaleX: 0 }}
                whileInView={{ scaleX: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: 0.3 }}
                style={{
                  height: "4px",
                  background:
                    "linear-gradient(90deg, var(--fuchsia), var(--gold))",
                  borderRadius: "2px",
                  originX: 0,
                  marginTop: "8px",
                }}
              />
            </div>
            <p
              style={{
                lineHeight: "1.9",
                color: "#55466b",
                fontWeight: 300,
                fontSize: "1.05rem",
                marginBottom: "24px",
              }}
            >
              Artem Clava transforms spaces into artistic experiences through
              murals, fine arts, and digital creativity. We believe every blank
              wall is an opportunity — a canvas waiting to tell a story.
            </p>
            <p
              style={{
                lineHeight: "1.9",
                color: "#55466b",
                fontWeight: 300,
                fontSize: "1.05rem",
              }}
            >
              Founded by passionate artists and educators, we blend traditional
              techniques with modern creativity to bring luxury art experiences
              to homes, institutions, and communities across the Globe.
            </p>
            <br />
            <p
              style={{
                lineHeight: "1.9",
                color: "#55466b",
                fontWeight: 300,
                fontSize: "1.05rem",
              }}
            >
              Every brushstroke is a breath released, every canvas, a wound
              finding peace.
            </p>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "10px",
                marginTop: "32px",
              }}
            >
              {[
                "Creativity",
                "Expression",
                "Mastery",
                "Community",
                "Healing",
              ].map((v, i) => (
                <motion.span
                  key={i}
                  whileHover={{ scale: 1.08, y: -3 }}
                  style={{
                    padding: "8px 20px",
                    borderRadius: "50px",
                    background: [
                      "linear-gradient(135deg,var(--fuchsia),var(--lavender))",
                      "linear-gradient(135deg,var(--teal),var(--lavender))",
                      "linear-gradient(135deg,var(--gold),var(--coral))",
                      "linear-gradient(135deg,var(--coral),var(--fuchsia))",
                      "linear-gradient(135deg,var(--lavender),var(--teal))",
                    ][i],
                    color: "#fff",
                    fontWeight: 600,
                    fontSize: "0.85rem",
                    cursor: "default",
                    display: "inline-block",
                  }}
                >
                  {v}
                </motion.span>
              ))}
            </div>
          </motion.div>
          <motion.div variants={fadeUp}>
            <motion.div
              whileHover={{ scale: 1.02 }}
              transition={{ type: "spring", stiffness: 180 }}
              style={{
                position: "relative",
                width: "100%",
                height: "600px",
                overflow: "hidden",
                borderRadius: "35px 10px 35px 10px",
                boxShadow:
                  "10px 10px 0 var(--fuchsia), 18px 18px 0 var(--gold)",
              }}
            >
              <motion.img
                key={currentSlide}
                src={works[currentSlide]}
                alt="Artwork"
                initial={{ opacity: 0, scale: 1.08 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 1 }}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  position: "absolute",
                  inset: 0,
                }}
              />
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  background:
                    "linear-gradient(to top, rgba(0,0,0,0.55), transparent)",
                }}
              />
              <div
                style={{
                  position: "absolute",
                  bottom: "25px",
                  left: "25px",
                  color: "#fff",
                }}
              >
                <h3
                  style={{
                    fontFamily: "var(--font-serif)",
                    fontSize: "2rem",
                    marginBottom: "8px",
                  }}
                >
                  Our Works
                </h3>
                <p
                  style={{
                    opacity: 0.8,
                    fontSize: "0.95rem",
                    letterSpacing: "1px",
                  }}
                >
                  Artistic Expressions by Artem Clava
                </p>
              </div>
              <div
                style={{
                  position: "absolute",
                  bottom: "25px",
                  right: "25px",
                  display: "flex",
                  gap: "8px",
                }}
              >
                {works.map((_, index) => (
                  <div
                    key={index}
                    onClick={() => setCurrentSlide(index)}
                    style={{
                      width: currentSlide === index ? "24px" : "10px",
                      height: "10px",
                      borderRadius: "50px",
                      background:
                        currentSlide === index
                          ? "var(--gold)"
                          : "rgba(255,255,255,0.5)",
                      transition: "0.4s ease",
                      cursor: "pointer",
                    }}
                  />
                ))}
              </div>
            </motion.div>
          </motion.div>
        </motion.div>
      </section>
      <section style={{ padding: "80px 10%", background: "var(--cream)" }}>
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          style={{
            fontFamily: "var(--font-serif)",
            fontStyle: "italic",
            fontSize: "2.5rem",
            color: "var(--ink)",
            textAlign: "center",
            marginBottom: "60px",
          }}
        >
          Meet the <span style={{ color: "var(--fuchsia)" }}>Founders</span>
        </motion.h2>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            gap: "60px",
            maxWidth: "900px",
            margin: "0 auto",
          }}
        >
          {[
            {
              name: "Gia Balan",
              role: "Founder & CEO",
              phone: "+91 6383283731",
              email: "giabalan@artemclava.in",
              image: "/founder.jpeg",
              color: "var(--fuchsia)",
            },
            {
              name: "Saran",
              role: "Co-Founder & COO",
              phone: "+91 8939774383",
              email: "saran@artemclava.in",
              image: "/co founder.jpeg",
              color: "var(--teal)",
            },
          ].map((person, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.2 }}
              whileHover={{ y: -8 }}
              style={{
                background: "#fff",
                borderRadius: "24px",
                overflow: "hidden",
                boxShadow: "0 8px 32px rgba(0,0,0,0.10)",
                textAlign: "center",
              }}
            >
              <div style={{ height: "5px", background: person.color }} />
              <div style={{ padding: "36px 36px 0" }}>
                <img
                  src={person.image}
                  alt={person.name}
                  style={{
                    width: "195px",
                    height: "230px",
                    borderRadius: "60%",
                    objectFit: "cover",
                    border: `4px solid ${person.color}`,
                    boxShadow: "0 6px 24px rgba(0,0,0,0.12)",
                  }}
                />
              </div>
              <div style={{ padding: "20px 36px 36px" }}>
                <h3
                  style={{
                    fontFamily: "var(--font-serif)",
                    fontSize: "1.4rem",
                    fontWeight: 700,
                    color: "var(--ink)",
                    marginBottom: "6px",
                  }}
                >
                  {person.name}
                </h3>
                <p
                  style={{
                    fontFamily: "var(--font-sans)",
                    fontSize: "0.95rem",
                    fontWeight: 600,
                    color: person.color,
                    marginBottom: "20px",
                    letterSpacing: "0.5px",
                  }}
                >
                  {person.role}
                </p>
                <p
                  style={{
                    fontFamily: "var(--font-sans)",
                    fontSize: "0.88rem",
                    fontWeight: 400,
                    color: "#555",
                    marginBottom: "8px",
                  }}
                >
                  {person.email}
                </p>
                <p
                  style={{
                    fontFamily: "var(--font-sans)",
                    fontSize: "0.88rem",
                    fontWeight: 400,
                    color: "#555",
                    marginBottom: "20px",
                  }}
                >
                  {person.phone}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </section>
    </motion.div>
  );
}
export default About;
